import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import PageActionBar from 'components/PageActionBar';
import UserFilters from 'components/Filters/UserFilters';
import InstallerList from './installerList';
import InstallerNew from './installerNew';
import InstallerDetails from './installerDetails';
import InstallerEdit from './installerEdit';
import {
  navigate,
  navigateBack,
  setInstallerFilters,
  resetInstallerFilters,
  requestWorkroomList,
  requestSurfaceTypesList } from 'actionCreators';
import { getInstallerFilters, getRole } from '../../../../reducers';
import ui from 'redux-ui';
import contentAreaStyles from 'styles/contentArea';

class Installers extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.addAction = this.addAction.bind(this);
    this.toggleFilterDrawer = () => {
      this.setState({ showFilterDrawer: !this.state.showFilterDrawer });
    };
    this.handleFilterChange = filters => this.props.setInstallerFilters(filters);
    this.state = { showFilterDrawer: false };
    this.isIndexRoute = () => this.props.location.pathname === this.props.route.path;
  }

  componentDidMount = () => {
    this.props.requestWorkroomList();
    this.props.requestSurfaceTypesList();
  }

  onSearch = (e, value) => {
    e.preventDefault();
    const filters = { ...this.props.filters };
    filters.query = value;
    this.handleFilterChange(filters);
  }

  addAction = () => this.props.navigate('/installers/new');

  render = () => {
    const showFiltersDrawer = this.isIndexRoute();
    const searchText = 'Search for an installer...';
    return (<div>
      <PageActionBar
        resource="installer"
        role={this.props.role}
        hidesAddOnMobile
        addAction={this.addAction}
        showFiltersBtn={showFiltersDrawer}
        title="Installer Management"
        subTitle="(Subcontractor)"
        searchText={searchText}
        toggleFilters={this.toggleFilterDrawer}
        onSearch={this.onSearch}
        path={this.props.location.pathname}
      />
      <div className={contentAreaStyles.contentAreaContainer}>
        {this.props.children}
        <UserFilters
          active={this.state.showFilterDrawer}
          onOverlayClick={this.toggleFilterDrawer}
          handleFilterChange={this.handleFilterChange}
          filters={this.props.filters}
          title="Installers"
          reset={this.props.resetInstallerFilters}
          role={this.props.role}
          resource="installer"
        />
      </div>
    </div>);
  }
}

Installers.propTypes = {
  role: PropTypes.string,
  location: PropTypes.object,
  route: PropTypes.object,
  navigate: PropTypes.func,
  setInstallerFilters: PropTypes.func,
  resetInstallerFilters: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  filters: PropTypes.object,
  requestWorkroomList: PropTypes.func,
  requestSurfaceTypesList: PropTypes.func,
};

const mapStateToProps = state => ({
  role: getRole(state), filters: getInstallerFilters(state),
});

export default ui({ key: 'installers', state: { successMessage: '', activeTab: 0 } })(connect(
  mapStateToProps, {
    navigate,
    navigateBack,
    setInstallerFilters,
    resetInstallerFilters,
    requestWorkroomList,
    requestSurfaceTypesList,
  },
)(Installers));

export { InstallerList, InstallerDetails, InstallerNew, InstallerEdit };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/index.jsx